import App from './container';

export default App;
